import React, { useEffect, useState, useContext, useMemo, useRef } from 'react';
import { debounce, isEmpty } from 'lodash';
import List from '@shared/component/List';
import { AuthContext } from '@shared/context/AuthContext';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Lists from '@shared/component/Lists';
import StatusDropDown from '@shared/component/StatusDropDown';
import moment from 'moment';
import { actionsPermissionValidator, ActionValues } from '@utils/static/commonUtils';

function SignupRequest() {
    const listRef: any = useRef(null);
    const { setLoader } = useContext(AuthContext);
    const [listData, setlistData] = useState([]);
    const [recordCount, setRecordCount] = useState(0);
    const [showHideModel, setShowHideModel] = useState(false);
    const [popUp, setPopUp] = useState(false);
    const [documentStatus, setdocumentStatus] = useState('Verified');
    const [documnetId, setDocumentId] = useState(null);
    const [edit, setEdit] = useState(false);
    const [editData, setEditData] = useState<any>([]);
    const [editId, setEditId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const [columns, setColumns] = useState({
        id: 'ID',
        name: 'Full Name',
        phone: 'Mobile No.',
        'category.name': 'Category',
        'documents.gstDoc': 'GST Certificate',
        'documents.panDoc': 'PAN',
        'documents.idProof': 'Aadhar',
        statusSignUpReq: 'Status',
        actionSignUpReq: 'Action',
    });

    const checkResnedValid = item => {
        let status = false;
        try {
            const date1 = moment(item.createdAt);
            const date2 = moment();
            const daysDifference = date2.diff(date1, 'hours');
            if (
                isEmpty(item?.documents?.pincode) &&
                isEmpty(item?.documents?.aadharNo) &&
                isEmpty(item?.documents?.panNo) &&
                item.documentStatus == 'Pending' &&
                daysDifference > 48
            ) {
                status = true;
            }
            return status;
        } catch (error) {
            return status;
        }
    };

    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const { data } = await APIService.getAll(
                `user/webuser/search/signup?page=${page}&order=desc&sort=createdAt&search=${value}&type=sign`,
                true,
                false,
            );
            setlistData(data.data);
            setRecordCount(data.count);
        } catch (err) {
            setLoader(false);
        }
    };

    // copy ClipBoard
    const CopyToClipboardFallback = text => {
        const textArea = document.createElement('textarea');
        textArea.value = text;

        // Prevent the text area from being visible and affecting layout
        textArea.style.position = 'fixed';
        textArea.style.top = '-9999px';
        textArea.style.left = '-9999px';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            const successful = document.execCommand("copy", true, text);
            const msg = successful ? 'successful' : 'unsuccessful';
            Notify('success', 'Copied successfully');
        } catch (err) {
            Notify('error', 'Unable to copy link');
        }

        // document.body.removeChild(textArea);
    };

    // Copy clipboard function

    const copyToClipboard = async text => {
        try {
            await navigator.clipboard.writeText(text);
            Notify('success', 'Copied successfully');
        } catch (err) {
            CopyToClipboardFallback(text);
        }
    };

    const UpdateAll = async (item: any, status: any, id: any) => {
        try {
            setLoader(true);
            const data = {
                status: documentStatus,
            };

            const updateddata = await APIService.update('app/user/verified', documnetId, data, true, false);
            setLoader(false);
            if (updateddata.status === 200) {
                handelModel(false);
                Notify('success', ' Document  status updated');
                getList(currentPage);
            }
        } catch (error) {
            setLoader(false);
        }
    };

    // update status
    const updateStatus = async (item: any, status: any, id: any) => {
        try {
            setDocumentId(id);
            setdocumentStatus(status);
            handlePopUp(true);
        } catch (err) {
            setLoader(false);
        }
    };

    const getList = async (page: any = 1) => {
        try {
            setLoader(true);
            setCurrentPage(page);
            const { data } = await APIService.getAll(
                `user/get/signUpAppUserList/?page=${page}&sort=createdAt&order=desc`,
                true,
                false,
            );
            setlistData(data.data);

            setRecordCount(data.count);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
        } catch (error) { }
    };

    // delete
    const getDeleteIds = async (ids: any) => {
        try {
            const data = {
                ids: JSON.stringify(ids),
            };

            setLoader(true);
            const updateddata = await APIService.post('location/delete/location', data, false, true);
            Notify('success', 'Location delete successfully');
            getList();
            setLoader(false);
        } catch (error) {
            setLoader(false);
        }
    };

    const handleEdit = (itemId: any) => {
        setEditId(itemId);
        const itemToEdit: any = listData?.find((item: any) => item.id === itemId);
        if (itemToEdit) {
            setEdit(true);
            setEditId(itemId);
            handelModel(true);
            setEditData({ ...itemToEdit });
        }
    };

    const handlePopUp = flag => {
        setPopUp(flag);
    };

    useEffect(() => {
        getList();
    }, []);

    const resendLink = async (e: any) => {
        try {
            let type: any = null;
            if (e?.category?.name === 'transporter') {
                type = 'transporter';
            } else {
                type = 'other';
            }
            const { name, phone, id, companyname, items } = e;
            const data = {
                name: name,
                phone: phone,
                companyname: companyname,
                id: id,
                items: items,
                type: type,
            };

            setLoader(true);
            const updateddata = await APIService.post('user/resendUserLink', data, true, false);
            setLoader(false);
            Notify('success', 'Link sent successfully');
            getList();
        } catch (error) {
            setLoader(false);
        }
    };

    return (
        <>
            <div className="container-fluid">
                <div className="main_body_cover">
                    <div className="container dash-container">
                        <div className="dash_bread_box">
                            <ul>
                                <li>Sign Up Requests</li>
                            </ul>
                        </div>
                        <div className="content_body_cover">
                            <Lists
                                ref={listRef}
                                headers={columns}
                                data={listData}
                                getById={handleEdit}
                                searchItem={searchItem}
                                updateStatus={updateStatus}
                                callPagination={getList}
                                recordCount={recordCount}
                                resendLink={resendLink}
                                Copy={copyToClipboard}
                            />
                        </div>
                    </div>
                </div>
                {popUp && (
                    <Modal
                        scrollable={true}
                        show={true}
                        onHide={() => handlePopUp(false)}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Document {documentStatus}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="model">
                                <div className="text_box">
                                    <h3>
                                        Are you sure, do you want to{' '}
                                        {documentStatus == 'Verified'
                                            ? 'verify'
                                            : documentStatus == 'Rejected'
                                                ? 'reject'
                                                : 'pending'}{' '}
                                        this user ?
                                    </h3>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="danger"
                                onClick={() => {
                                    handlePopUp(false);
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="secondary"
                                className="btn btn-success"
                                onClick={() => {
                                    UpdateAll('', documentStatus, documnetId);
                                    handlePopUp(false);
                                }}
                            >
                                Yes
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

                {showHideModel && (
                    <Modal
                        scrollable={true}
                        show={true}
                        onHide={() => handelModel(false)}
                        backdrop="static"
                        size="lg"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>View User</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="detail_modal_cover">
                                <div className="details_box_cover">
                                    {editData?.category?.name == 'transporter' ? (
                                        <div className="container">
                                            <h3>User Details</h3>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">Company Name :</span>
                                                            <span className="main_box">{editData?.companyname}</span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">Mobile No. :</span>
                                                            <span className="main_box">{editData?.phone}</span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">Category :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.category?.name
                                                                    ? editData.category.name
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">Owner Name :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.name ? editData.name : 'N/A'}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">Email :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.email ? editData.email : 'N/A'}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">State :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.documents?.state
                                                                    ? editData.documents.state
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">City :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.documents?.city
                                                                    ? editData.documents.city
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">Pincode :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.documents?.pincode
                                                                    ? editData.documents.pincode
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">Full Address :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.documents?.address
                                                                    ? editData.documents.address
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <hr />
                                            <h3>Documents :</h3>
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <p className="sub_box">Aadhar No. </p>
                                                            <p className="main_box">
                                                                {editData && editData?.documents?.aadharNo
                                                                    ? editData.documents.aadharNo
                                                                    : 'N/A'}
                                                            </p>
                                                            {editData?.documents?.idProof ? (
                                                                <>
                                                                    <p className="sub_box">Uploaded Document </p>
                                                                    <a
                                                                        href={
                                                                            process.env.REACT_APP_API_BASE +
                                                                            editData?.documents?.idProof
                                                                        }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div>
                                                                            {editData?.documents?.idProof.split(
                                                                                '.',
                                                                            )[1] != 'png'}
                                                                            {editData?.documents?.idProof.split(
                                                                                '.',
                                                                            )[1] != 'jpeg' &&
                                                                                editData?.documents?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                editData?.documents?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                <div className="previewpdfsignup">
                                                                                    <img
                                                                                        src="./assets/images/pdficon.svg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="previewimagesignup">
                                                                                    <img
                                                                                        src={
                                                                                            process.env
                                                                                                .REACT_APP_API_BASE +
                                                                                            editData?.documents?.idProof
                                                                                        }
                                                                                        className="img-fluid w-100 h-100"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="previewimagesignuptext">
                                                                                {editData?.documents?.idProof
                                                                                    .split('documents')[1]
                                                                                    .slice(12)}
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-4">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <p className="sub_box">PAN No. </p>
                                                            <p className="main_box">
                                                                {editData && editData?.documents?.panNo
                                                                    ? editData?.documents?.panNo
                                                                    : 'N/A'}
                                                            </p>
                                                            {editData?.documents?.panDoc ? (
                                                                <>
                                                                    <p className="sub_box">Uploaded Document </p>

                                                                    <a
                                                                        href={
                                                                            process.env.REACT_APP_API_BASE +
                                                                            editData?.documents?.panDoc
                                                                        }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div>
                                                                            {editData?.documents?.panDoc.split(
                                                                                '.',
                                                                            )[1] != 'png'}
                                                                            {editData?.documents?.panDoc.split(
                                                                                '.',
                                                                            )[1] != 'jpeg' &&
                                                                                editData?.documents?.panDoc.split('.')[1] !=
                                                                                'jpg' &&
                                                                                editData?.documents?.panDoc.split('.')[1] !=
                                                                                'png' ? (
                                                                                <div className="previewpdfsignup">
                                                                                    <img
                                                                                        src="./assets/images/pdficon.svg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="previewimagesignup">
                                                                                    <img
                                                                                        src={
                                                                                            process.env
                                                                                                .REACT_APP_API_BASE +
                                                                                            editData?.documents?.panDoc
                                                                                        }
                                                                                        className="img-fluid w-100 h-100"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="previewimagesignuptext">
                                                                                {editData?.documents?.panDoc
                                                                                    .split('documents')[1]
                                                                                    .slice(12)}
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-4">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <p className="sub_box">GST Certificate No.</p>
                                                            <p className="main_box">
                                                                {editData && editData?.documents?.gstNo
                                                                    ? editData.documents.gstNo
                                                                    : ' N/A'}
                                                            </p>
                                                            {editData?.documents?.gstDoc ? (
                                                                <>
                                                                    <p className="sub_box">Uploaded Document </p>
                                                                    <a
                                                                        href={
                                                                            process.env.REACT_APP_API_BASE +
                                                                            editData?.documents?.gstDoc
                                                                        }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div>
                                                                            {editData?.documents?.gstDoc.split(
                                                                                '.',
                                                                            )[1] != 'png'}
                                                                            {editData?.documents?.gstDoc.split(
                                                                                '.',
                                                                            )[1] != 'jpeg' &&
                                                                                editData?.documents?.gstDoc.split('.')[1] !=
                                                                                'jpg' &&
                                                                                editData?.documents?.gstDoc.split('.')[1] !=
                                                                                'png' ? (
                                                                                <div className="previewpdfsignup">
                                                                                    <img
                                                                                        src="./assets/images/pdficon.svg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="previewimagesignup">
                                                                                    <img
                                                                                        src={
                                                                                            process.env
                                                                                                .REACT_APP_API_BASE +
                                                                                            editData?.documents?.gstDoc
                                                                                        }
                                                                                        className="img-fluid w-100 h-100"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="previewimagesignuptext">
                                                                                {editData?.documents?.gstDoc
                                                                                    .split('documents')[1]
                                                                                    .slice(12)}
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                {editData?.documents?.otherDoc ? (
                                                    <div className="col-sm-4">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <p className="sub_box">Other</p>
                                                                <p className="sub_box">Uploaded Document </p>
                                                                {editData?.documents?.otherDoc ? (
                                                                    <a
                                                                        href={
                                                                            process.env.REACT_APP_API_BASE +
                                                                            editData?.documents?.otherDoc
                                                                        }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div>
                                                                            {editData?.documents?.otherDoc.split(
                                                                                '.',
                                                                            )[1] != 'png'}
                                                                            {editData?.documents?.otherDoc.split(
                                                                                '.',
                                                                            )[1] != 'jpeg' &&
                                                                                editData?.documents?.otherDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                editData?.documents?.otherDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                <div className="previewpdfsignup">
                                                                                    <img
                                                                                        src="./assets/images/pdficon.svg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="previewimagesignup">
                                                                                    <img
                                                                                        src={
                                                                                            process.env
                                                                                                .REACT_APP_API_BASE +
                                                                                            editData?.documents
                                                                                                ?.otherDoc
                                                                                        }
                                                                                        className="img-fluid w-100 h-100"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="previewimagesignuptext">
                                                                                {editData?.documents?.otherDoc
                                                                                    .split('documents')[1]
                                                                                    .slice(12)}
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="container">
                                            <h3>User Details</h3>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">Company Name :</span>
                                                            <span className="main_box">{editData?.companyname}</span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">Mobile No :</span>
                                                            <span className="main_box">{editData?.phone}</span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">Category :</span>
                                                            <span className="main_box">{editData?.category?.name}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">Owner Name :</span>
                                                            <span className="main_box">{editData?.name}</span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">Email :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.email ? editData.email : 'N/A'}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">State :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.documents?.state
                                                                    ? editData.documents.state
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">City :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.documents?.city
                                                                    ? editData.documents.city
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span className="sub_box">Pincode :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.documents?.pincode
                                                                    ? editData.documents.pincode
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">Full Address :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.documents?.address
                                                                    ? editData.documents.address
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <br></br>
                                            <hr />
                                            <br></br>

                                            <h3>Item List :</h3>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">Category :</span>
                                                            <span className="main_box">
                                                                {editData && editData?.category?.name
                                                                    ? editData.category.name
                                                                    : 'N/A'}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-6">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <span className="sub_box">Item Name :</span>
                                                            <span className="main_box">
                                                                {editData?.items.map((permission: any, idx: any) => (
                                                                    <span key={idx}>
                                                                        {permission?.name ? permission?.name : 'N/A'}
                                                                        {idx !== editData?.items.length - 1 && ', '}
                                                                    </span>
                                                                ))}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <hr />
                                            <h3>Documents :</h3>
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <p className="sub_box">Aadhar No. </p>
                                                            <p className="main_box">
                                                                {editData && editData?.documents?.aadharNo
                                                                    ? editData.documents?.aadharNo
                                                                    : 'N/A'}
                                                            </p>
                                                            {editData?.documents?.idProof ? (
                                                                <>
                                                                    <p className="sub_box">Uploaded Document </p>
                                                                    <a
                                                                        href={
                                                                            process.env.REACT_APP_API_BASE +
                                                                            editData?.documents?.idProof
                                                                        }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div>
                                                                            {editData?.documents?.idProof.split(
                                                                                '.',
                                                                            )[1] != 'png'}
                                                                            {editData?.documents?.idProof.split(
                                                                                '.',
                                                                            )[1] != 'jpeg' &&
                                                                                editData?.documents?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                editData?.documents?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                <div className="previewpdfsignup">
                                                                                    <img
                                                                                        src="./assets/images/pdficon.svg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="previewimagesignup">
                                                                                    <img
                                                                                        src={
                                                                                            process.env
                                                                                                .REACT_APP_API_BASE +
                                                                                            editData?.documents?.idProof
                                                                                        }
                                                                                        className="img-fluid w-100 h-100"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="previewimagesignuptext">
                                                                                {editData?.documents?.idProof
                                                                                    .split('documents')[1]
                                                                                    .slice(12)}
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-4">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <p className="sub_box">PAN No. </p>
                                                            <p className="main_box">
                                                                {editData && editData?.documents?.panNo
                                                                    ? editData.documents.panNo
                                                                    : 'N/A'}
                                                            </p>
                                                            {editData?.documents?.panDoc ? (
                                                                <>
                                                                    <p className="sub_box">Uploaded Document </p>
                                                                    <a
                                                                        href={
                                                                            process.env.REACT_APP_API_BASE +
                                                                            editData?.documents?.panDoc
                                                                        }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div>
                                                                            {editData?.documents?.panDoc.split(
                                                                                '.',
                                                                            )[1] != 'png'}
                                                                            {editData?.documents?.panDoc.split(
                                                                                '.',
                                                                            )[1] != 'jpeg' &&
                                                                                editData?.documents?.panDoc.split('.')[1] !=
                                                                                'jpg' &&
                                                                                editData?.documents?.panDoc.split('.')[1] !=
                                                                                'png' ? (
                                                                                <div className="previewpdfsignup">
                                                                                    <img
                                                                                        src="./assets/images/pdficon.svg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="previewimagesignup">
                                                                                    <img
                                                                                        src={
                                                                                            process.env
                                                                                                .REACT_APP_API_BASE +
                                                                                            editData?.documents?.panDoc
                                                                                        }
                                                                                        className="img-fluid w-100 h-100"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="previewimagesignuptext">
                                                                                {editData?.documents?.panDoc
                                                                                    .split('documents')[1]
                                                                                    .slice(12)}
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-4">
                                                    <ul className="detail_list">
                                                        <li>
                                                            <p className="sub_box">GST Certificate No.</p>
                                                            <p className="main_box">
                                                                {editData && editData?.documents?.gstNo
                                                                    ? editData.documents.gstNo
                                                                    : 'N/A'}
                                                            </p>
                                                            {editData?.documents?.gstDoc ? (
                                                                <>
                                                                    <p className="sub_box">Uploaded Document </p>
                                                                    <a
                                                                        href={
                                                                            process.env.REACT_APP_API_BASE +
                                                                            editData?.documents?.gstDoc
                                                                        }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div>
                                                                            {editData?.documents?.gstDoc.split(
                                                                                '.',
                                                                            )[1] != 'png'}
                                                                            {editData?.documents?.gstDoc.split(
                                                                                '.',
                                                                            )[1] != 'jpeg' &&
                                                                                editData?.documents?.gstDoc.split('.')[1] !=
                                                                                'jpg' &&
                                                                                editData?.documents?.gstDoc.split('.')[1] !=
                                                                                'png' ? (
                                                                                <div className="previewpdfsignup">
                                                                                    <img
                                                                                        src="./assets/images/pdficon.svg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="previewimagesignup">
                                                                                    <img
                                                                                        src={
                                                                                            process.env
                                                                                                .REACT_APP_API_BASE +
                                                                                            editData?.documents?.gstDoc
                                                                                        }
                                                                                        className="img-fluid w-100 h-100"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="previewimagesignuptext">
                                                                                {editData?.documents?.gstDoc
                                                                                    .split('documents')[1]
                                                                                    .slice(12)}
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                                {editData?.documents?.otherDoc ? (
                                                    <div className="col-sm-4">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <p className="sub_box">Other</p>
                                                                <p className="sub_box">Uploaded Document </p>
                                                                {editData?.documents?.otherDoc ? (
                                                                    <a
                                                                        href={
                                                                            process.env.REACT_APP_API_BASE +
                                                                            editData?.documents?.otherDoc
                                                                        }
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div>
                                                                            {editData?.documents?.otherDoc.split(
                                                                                '.',
                                                                            )[1] != 'png'}
                                                                            {editData?.documents?.otherDoc.split(
                                                                                '.',
                                                                            )[1] != 'jpeg' &&
                                                                                editData?.documents?.otherDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                editData?.documents?.otherDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                <div className="previewpdfsignup">
                                                                                    <img
                                                                                        src="./assets/images/pdficon.svg"
                                                                                        className="img-fluid"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="previewimagesignup">
                                                                                    <img
                                                                                        src={
                                                                                            process.env
                                                                                                .REACT_APP_API_BASE +
                                                                                            editData?.documents
                                                                                                ?.otherDoc
                                                                                        }
                                                                                        className="img-fluid w-100 h-100"
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="previewimagesignuptext">
                                                                                {editData?.documents?.otherDoc
                                                                                    .split('documents')[1]
                                                                                    .slice(12)}
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {actionsPermissionValidator(location.pathname, ActionValues.Edit) ? (
                                <>
                                    {editData.documentStatus == 'Pending' ? (
                                        <>
                                            <Button
                                                variant="secondary"
                                                className="btn btn-success"
                                                onClick={() => {
                                                    setdocumentStatus('Verified');
                                                    setDocumentId(editId);
                                                    handelModel(false);
                                                    handlePopUp(true);
                                                }}
                                            >
                                                Verified
                                            </Button>
                                            <Button
                                                variant="secondary"
                                                className="btn btn-danger"
                                                onClick={() => {
                                                    setdocumentStatus('Rejected');
                                                    setDocumentId(editId);
                                                    handelModel(false);
                                                    handlePopUp(true);
                                                }}
                                            >
                                                Rejected
                                            </Button>
                                        </>
                                    ) : editData.documentStatus == 'Rejected' ? (
                                        <Button
                                            variant="secondary"
                                            className="btn btn-success"
                                            onClick={() => {
                                                setdocumentStatus('Verified');
                                                setDocumentId(editId);
                                                handelModel(false);
                                                handlePopUp(true);
                                            }}
                                        >
                                            Verified
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="secondary"
                                            className="btn btn-danger"
                                            //  onClick={() => handelModel(false)}>
                                            onClick={() => {
                                                setdocumentStatus('Rejected');
                                                setDocumentId(editId);
                                                handelModel(false);
                                                handlePopUp(true);
                                            }}
                                        >
                                            Rejected
                                        </Button>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        </>
    );
}

export default SignupRequest;
